import React from 'react';
import BrowserFrame from './BrowserFrame';

const CRMHub: React.FC = () => {
  const systems = [
    { label: 'Salesforce', color: '#00A1E0', x: 40, y: 30 },
    { label: 'HubSpot', color: '#FF7A59', x: 240, y: 30 },
    { label: 'Zoho', color: '#E42527', x: 40, y: 160 },
    { label: 'Odoo', color: '#714B67', x: 240, y: 160 },
  ];

  return (
    <BrowserFrame url="miid.app/crm/hub">
      <div style={{ padding: '1rem', background: 'var(--cream)', minHeight: '260px', fontFamily: "'Montserrat', sans-serif" }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '.9rem' }}>
          <div style={{ fontSize: '.72rem', fontWeight: 600, color: 'var(--ink)' }}>Intégration CRM</div>
          <div style={{ fontSize: '.5rem', color: 'var(--ink2)' }}>4 systèmes synchronisés</div>
        </div>

        <div style={{ position: 'relative', height: '200px', background: 'var(--white)', border: '1px solid var(--border)', borderRadius: '4px', overflow: 'hidden' }}>
          <svg viewBox="0 0 320 200" style={{ width: '100%', height: '100%', position: 'absolute', inset: 0 }}>
            <defs>
              <linearGradient id="flowGrad" x1="0" y1="0" x2="1" y2="0">
                <stop offset="0%" stopColor="var(--blue)" stopOpacity="0" />
                <stop offset="50%" stopColor="var(--blue)" stopOpacity="1" />
                <stop offset="100%" stopColor="var(--blue)" stopOpacity="0" />
              </linearGradient>
            </defs>

            {/* Connection lines */}
            {systems.map((s, i) => (
              <line
                key={i}
                x1={s.x + 30}
                y1={s.y + 20}
                x2="160"
                y2="100"
                stroke="var(--blue)"
                strokeOpacity=".2"
                strokeWidth="1"
                strokeDasharray="3 3"
              />
            ))}

            {/* Animated particles along lines */}
            {systems.map((s, i) => (
              <circle key={`p-${i}`} r="2.5" fill="var(--gold)">
                <animateMotion dur={`${2 + i * 0.4}s`} repeatCount="indefinite" path={`M ${s.x + 30} ${s.y + 20} L 160 100`} />
              </circle>
            ))}

            {/* Central hub */}
            <circle cx="160" cy="100" r="26" fill="var(--blue)" />
            <circle cx="160" cy="100" r="34" fill="none" stroke="var(--blue)" strokeOpacity=".2" strokeWidth="1">
              <animate attributeName="r" values="34;42;34" dur="2.4s" repeatCount="indefinite" />
              <animate attributeName="opacity" values=".3;0;.3" dur="2.4s" repeatCount="indefinite" />
            </circle>
            <text x="160" y="104" textAnchor="middle" fill="white" fontFamily="'Cormorant Garamond', serif" fontSize="14" fontWeight="600">
              MIID
            </text>
          </svg>

          {/* System badges positioned absolutely */}
          {systems.map((s) => (
            <div
              key={s.label}
              style={{
                position: 'absolute',
                left: `${(s.x / 320) * 100}%`,
                top: `${(s.y / 200) * 100}%`,
                width: '60px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'var(--white)',
                border: `1.5px solid ${s.color}`,
                borderRadius: '4px',
                fontSize: '.5rem',
                fontWeight: 700,
                color: s.color,
                boxShadow: '0 2px 8px rgba(0,0,0,.08)',
              }}
            >
              {s.label}
            </div>
          ))}
        </div>

        {/* Sync indicators */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '.5rem', marginTop: '.7rem' }}>
          {[
            { label: 'Contacts syncés', value: '12 847' },
            { label: 'Deals actifs', value: '438' },
            { label: 'Sync temps réel', value: '✓ OK' },
          ].map((k) => (
            <div key={k.label} style={{ background: 'var(--white)', border: '1px solid var(--border)', padding: '.4rem .55rem', borderRadius: '4px' }}>
              <div style={{ fontSize: '.42rem', color: 'var(--ink2)', letterSpacing: '.08em', textTransform: 'uppercase' }}>{k.label}</div>
              <div style={{ fontSize: '.72rem', fontWeight: 700, color: 'var(--blue)', fontFamily: "'Cormorant Garamond', serif" }}>{k.value}</div>
            </div>
          ))}
        </div>
      </div>
    </BrowserFrame>
  );
};

export default CRMHub;
